const ellipsis = "data:image/svg+xml,%3csvg%20width='18'%20height='4'%20viewBox='0%200%2018%204'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20transform='rotate(90)%20translate(-0.5%20-17.5)'%20d='M1%203.5a1.5%201.5%200%201%201%203%200%201.5%201.5%200%200%201-3%200zm0%205.25a1.5%201.5%200%201%201%203%200%201.5%201.5%200%200%201-3%200zM1%2014a1.5%201.5%200%201%201%203%200%201.5%201.5%200%200%201-3%200z'%20fill-rule='evenodd'/%3e%3c/svg%3e";
export {
  ellipsis as default
};
//# sourceMappingURL=ellipsis.svg.es.js.map
